module.exports = __webpack_public_path__ + "img/ban_7.15c097b2.png";